import React, { useState, useEffect } from "react";
// import "./planpagelayout.css";
import { useDispatch, useSelector } from "react-redux";
import axiosCommercial from "../../../Redux/axios/AxiosCommercial";
import {
  setCommercialQuickQuotes,
  setCommercialErrQuotes,
  setQuickQuotePost,
  setQuickQuoteValues,
} from "../../../Redux/actions/CommercialSlice";
import { Button, Form, Radio, message } from "antd/lib";
import moment from "moment";

export default function CommercialPrevpolictype({
  setIsModalOpen,
  CommerDetail,
}) {
  const dispatch = useDispatch();
  const auth = CommerDetail.commercialnum;
  const vechicleData = useSelector((state) => state?.common?.vahanData);
  const QuickQuotes = useSelector((state) => state?.cardetail?.quickquotes);
  console.log("QuickQuotes", QuickQuotes);
  const QuickQuotePost = useSelector(
    (state) => state?.cardetail?.quickQuotePost
  );
  const QuoteInput = useSelector((state) => state?.cardetail?.quoteInput);
  console.log(QuickQuotePost);
  // const [QuotePost, setQuotePost] = useState(QuickQuotePost)
  const [loading, setLoading] = useState(false);

  const onChange = (e) => {
    console.log("radio checked", e.target.value);
    // setValue(e.target.value);
  };
  const onFinish = (values) => {
    console.log("product values", values);
    const productcode = values.product;
    const productCodeMap = {
      "PASSENGER CARRYING VEHICLE": {
        package: "PCP",
        tp: "PCT",
        Not_Secure: "PCT",
      },
      "GOODS COMMERCIAL VEHICLE": {
        package: "GCP",
        tp: "GCT",
        Not_Secure: "GCT",
      },
      "MISCELLANEOUS VEHICLE": { package: "MCP", tp: "MCT", Not_Secure: "MCT" },
    };
    const registrationDate = moment(QuickQuotePost?.registrationDate).format(
      "YYYY-MM-DD"
    );
    const regDate = new Date(registrationDate);
    regDate.setFullYear(regDate.getFullYear() + 5);

    const updateQuoteInput = {
      ...QuoteInput,
      insuranceProductCode: productcode,
      productCode:
        productcode === "Not_Secure"
          ? "PVT"
          : productcode === "Bundled"
          ? "PVS"
          : productcode,
      ncbvalue:
        productcode === "Not_Secure" || productcode === "PVT"
          ? ""
          : QuoteInput?.ncbvalue,
    };

    let currentTP = {
      currentThirdPartyPolicyNumber:
        productcode === "PVS" || productcode === "Bundled"
          ? vechicleData?.insurance_policy_number
          : null,
      currentThirdPartyPolicyInsurerCode:
        productcode === "PVS" || productcode === "Bundled" ? "115" : null,
      currentThirdPartyPolicyStartDateTime:
        productcode === "PVS" || productcode === "Bundled"
          ? moment(QuickQuotePost.registrationDate).format("YYYY-MM-DD")
          : null,
      currentThirdPartyPolicyExpiryDateTime:
        productcode === "PVS" || productcode === "Bundled"
          ? moment(regDate).format("YYYY-MM-DD")
          : null,
    };
    const updatedQuotePost = {
      ...QuickQuotePost,
      previousPolicyExpiryDate:
        productcode === "Not_Secure"
          ? moment(new Date()).format("YYYY-MM-DD")
          : QuickQuotePost?.previousPolicyExpiryDate,
      product_code:
        productCodeMap[CommerDetail?.commercialType]?.[
          values?.insuranceProductCode
        ] || null,
      currentThirdPartyPolicy:
        productcode === "PVS" || productcode === "Bundled" ? currentTP : null,
      originalPreviousPolicyType:
        productcode === "PVS"
          ? "1OD_0TP"
          : productcode === "Bundled"
          ? "1OD_3TP"
          : null,
      previousInsurerCode: productcode === "Not_Secure" ? null : "115",
      isPreviousInsurerKnown: productcode === "Not_Secure" ? 0 : 1, //0 r 1 int
    };
    console.log(updatedQuotePost);
    setLoading(true);
    axiosCommercial
      .post(
        `v2/commercial_insurances/${auth?.commercial_insurance_id}/quick_quotes`,
        updatedQuotePost
      )
      .then((res) => {
        if (res.status === 200) {
          const Udata = res?.data?.data;
          //console.log("data-----------------",data)
          const errData = Udata?.filter(
            (item) => "status" in item && item.status === "failed"
          );
          dispatch(setCommercialErrQuotes(errData));
          const filteredData = Udata?.filter(
            (item) => "status" in item && item.status === "success"
          );
          const updatedData = filteredData?.map((item) => ({
            ...item,
            IsGst: true,
          }));
          dispatch(setCommercialQuickQuotes(updatedData));

          dispatch(setQuickQuotePost(updatedQuotePost));
          dispatch(setQuickQuoteValues(updateQuoteInput));
          setLoading(false);
          setIsModalOpen(false);
          // } else {
          // message.error(res.data.error.validationMessages.join(","));
          // }
        }
      })
      .catch((err) => {
        console.log(err.response.data.error);
        setLoading(false);
        message.error(err.response.data.error);
      });
  };
  return (
    <>
      <Form onFinish={onFinish} layout="vertical" requiredMark={false}>
        <Form.Item
          name="product"
          label="It will help us to provide accurate quotes for you"
          rules={[
            {
              required: true,
              message: "Please select Policy Type",
            },
          ]}
          initialValue={QuoteInput?.insuranceProductCode}
        >
          <Radio.Group
            className="py-3 px-3 pb-0 bg-white ant-radio-layout prev-prod-sec"
            onChange={onChange}
          >
            <Radio value="PVP">Comprehensive</Radio>
            <Radio value="PVT">TP only</Radio>
            <Radio value="Not_Secure">Not Secure</Radio>
          </Radio.Group>
        </Form.Item>
        <Form.Item style={{ textAlign: "center" }}>
          <Button
            type="primary"
            htmlType="submit"
            className="update-qut-button"
            loading={loading}
          >
            Update
          </Button>
        </Form.Item>
      </Form>
    </>
  );
}
